import { useCallback, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import useDeeplinkRedirect from "../hooks/useDeeplinkRedirect";
import DeeplinkRedirect from "../components/mobile-app/DeeplinkRedirect";
import { recordLegacyQrScan } from "../common/services/qr-tracking";

export default function VendorProfileRedirect() {
  const { username } = useParams();
  const { search } = useLocation();
  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading"
  );
  const [message, setMessage] = useState("Redirecting...");

  const query = useMemo<Record<string, string>>(
    () => Object.fromEntries(new URLSearchParams(search)),
    [search]
  );

  // Mirrors the /share/:username Universal Link so both entry points open the same screen.
  const appPath = `share/${username ?? ""}`;

  const onMount = useCallback(async () => {
    const qrSource = query.qr_source;
    if (qrSource && username) {
      // Legacy QR pattern (…?qr_source=…) — record the scan like the new QR codes do.
      void recordLegacyQrScan(username, qrSource);
    }
  }, [query, username]);

  const beforeRedirect = useCallback(async () => {
    setStatus("success");
    setMessage("Redirecting...");
  }, []);

  const onError = useCallback(async (e: Error) => {
    setStatus("error");
    setMessage(
      e.message || "An error occurred while redirecting. Please try again."
    );
  }, []);

  useDeeplinkRedirect({
    path: appPath,
    query,
    onMount,
    beforeRedirect,
    onError,
  });

  return <DeeplinkRedirect status={status} message={message} />;
}
